import { useQuery } from '@tanstack/react-query'
import { Clock } from 'lucide-react'
import { getAttendanceSettings } from '../api/hrmsAttendanceSettings.api'
import { HRMS_ATTENDANCE_SETTINGS_QUERY_KEY } from '../hooks/useHrmsAttendanceSettings'
import type { AttendanceSettingsMeta } from '../types/hrmsAttendanceSettings.types'

interface ConfigurationContextBadgeProps {
  meta?: AttendanceSettingsMeta | null
}

export function ConfigurationContextBadge({ meta: propMeta }: ConfigurationContextBadgeProps) {
  const { data } = useQuery({
    queryKey: HRMS_ATTENDANCE_SETTINGS_QUERY_KEY,
    queryFn: getAttendanceSettings,
    staleTime: 5 * 60 * 1000,
  })

  const meta = propMeta ?? data?.meta
  const hasMetaDetails = meta && (meta.lastUpdatedBy || meta.lastUpdatedAt || meta.version)

  if (!hasMetaDetails) {
    return (
      <div className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-1.5 text-xs text-slate-600 border border-slate-200 shrink-0">
        <Clock className="h-3.5 w-3.5 text-slate-400" />
        <span>Settings synchronized with institutional database</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-1.5 text-xs text-slate-600 border border-slate-200 shrink-0">
      <Clock className="h-3.5 w-3.5 text-slate-400" />
      <span>
        Last updated {meta.lastUpdatedBy ? <>by <strong className="font-semibold text-slate-800">{meta.lastUpdatedBy}</strong></> : null}{' '}
        {meta.lastUpdatedAt ? <>on {meta.lastUpdatedAt}</> : null}
      </span>
      {meta.version && (
        <>
          <span className="text-slate-300">•</span>
          <span className="font-semibold text-[#146971]">Live Version {meta.version}</span>
        </>
      )}
    </div>
  )
}
